(function () {
  var ROOT_ID = 'rp-cart-drawer';
  var busy = false;

  function root() { return document.getElementById(ROOT_ID); }

  function open() { var r = root(); if (r) { r.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function close() { var r = root(); if (r) { r.classList.remove('is-open'); document.body.style.overflow = ''; } }

  /*
   * Recharge la section cote serveur : tous les prix et paliers sont recalcules en Liquid.
   * On passe par ?section_id= et non ?sections= : la Section Rendering API au format JSON
   * n'expose pas les sections rendues depuis layout/theme.liquid.
   */
  function refresh() {
    var r = root();
    var id = r ? r.dataset.section : null;
    if (!id) return Promise.resolve();
    var wasOpen = r.classList.contains('is-open');
    r.classList.add('is-busy');
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id))
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(ROOT_ID);
        var current = root();
        if (!fresh || !current) return;
        current.replaceWith(fresh);
        if (wasOpen) { fresh.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
        bind();
        return applyGift();
      })
      .catch(function () {})
      .then(function () { var c = root(); if (c) c.classList.remove('is-busy'); });
  }

  function changeLine(key, qty) {
    if (busy) return Promise.resolve();
    busy = true;
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { busy = false; return refresh(); })
      .catch(function () { busy = false; });
  }

  function addVariant(id, qty) {
    if (busy) return Promise.resolve();
    busy = true;
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function () { busy = false; return refresh(); })
      .catch(function () { busy = false; });
  }

  function removeVariant(id) {
    if (busy) return Promise.resolve();
    busy = true;
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var line = cart.items.filter(function (i) { return String(i.variant_id) === String(id); })[0];
      if (!line) { busy = false; return; }
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 0 })
      }).then(function () { busy = false; return refresh(); });
    }).catch(function () { busy = false; });
  }

  /* Le cadeau est ajoute ou retire selon l'instruction calculee en Liquid. */
  function applyGift() {
    var r = root();
    if (!r) return Promise.resolve();
    var action = r.dataset.giftAction;
    var vid = r.dataset.giftVariant;
    if (!vid || action === 'none' || !action) return Promise.resolve();
    if (action === 'add') return addVariant(vid, 1);
    if (action === 'remove') return removeVariant(vid);
    return Promise.resolve();
  }

  function bind() {
    var r = root();
    if (!r || r.dataset.bound === '1') return;
    r.dataset.bound = '1';

    r.querySelectorAll('[data-rp-cd-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    r.querySelectorAll('[data-rp-cd-qty]').forEach(function (el) {
      el.addEventListener('click', function () {
        changeLine(el.dataset.key, parseInt(el.dataset.rpCdQty, 10));
      });
    });
    r.querySelectorAll('[data-rp-cd-add]').forEach(function (el) {
      el.addEventListener('click', function () { addVariant(el.dataset.rpCdAdd, 1); });
    });
    var prot = r.querySelector('[data-rp-cd-prot]');
    if (prot) {
      prot.addEventListener('change', function () {
        var vid = r.dataset.protVariant;
        if (!vid) return;
        if (prot.checked) addVariant(vid, 1); else removeVariant(vid);
      });
    }
  }

  /* Le lien panier de l'entete ouvre le tiroir au lieu d'aller sur /cart. */
  function bindTriggers() {
    document.querySelectorAll('a[href$="/cart"], a[href*="/cart?"], [data-rp-cart-open]').forEach(function (el) {
      if (el.dataset.rpCartBound === '1') return;
      el.dataset.rpCartBound = '1';
      el.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
  }

  /*
   * La fiche produit poste un formulaire classique vers /cart/add, ce qui provoque
   * une navigation vers /cart. On intercepte en phase de capture pour transformer
   * l'envoi en ajout AJAX, puis on ouvre le tiroir.
   */
  function interceptForms() {
    if (window.rpCdFormsPatched) return;
    window.rpCdFormsPatched = true;
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      e.stopPropagation();
      if (busy) return;
      busy = true;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function () { busy = false; return refresh(); })
        .then(function () { open(); })
        .catch(function () { busy = false; });
    }, true);
  }

  /* Ouvre le tiroir apres un ajout AJAX fait par un autre script du theme. */
  function interceptAdds() {
    if (window.rpCdFetchPatched) return;
    window.rpCdFetchPatched = true;
    var orig = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var isAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
      var out = orig.apply(this, arguments);
      if (isAdd && !busy) {
        /*
         * UN FETCH QUI RECOIT UN 422 RESOUT QUAND MEME : seule une panne reseau
         * le rejette. Sans le test sur r.ok, ce .then partait donc aussi sur un
         * echec et ouvrait le tiroir sur un panier inchange. Constate le 13
         * septembre sur la fiche en ligne : /cart/add.js en 422, tiroir ouvert,
         * /cart.js a 0 article, et aucun message a l'ecran.
         *
         * On n'ouvre plus que sur un ajout reellement accepte. Le message
         * d'echec, lui, est affiche sous le bouton par le script qui a lance
         * l'ajout : c'est lui qui sait de quel bouton il s'agit.
         */
        out.then(function (r) {
          if (r && r.ok === false) return;
          refresh().then(open);
        }).catch(function () {});
      }
      return out;
    };
  }

  /*
   * Ouverture du tiroir a l'arrivee sur la page.
   *
   * La route /cart n'affiche plus de page panier : elle renvoie vers la fiche
   * produit et laisse un drapeau en sessionStorage (voir sections/rp-redirect.liquid).
   * On le consomme ici pour que la cliente retrouve son panier ouvert la ou il
   * doit s'afficher, au lieu d'atterrir sur la fiche sans rien comprendre.
   *
   * Le drapeau est retire des sa lecture : sinon le tiroir se rouvrirait a chaque
   * navigation de la session.
   */
  function ouvrirSiDemande() {
    try {
      if (!sessionStorage.getItem('rpOuvrirPanier')) return;
      sessionStorage.removeItem('rpOuvrirPanier');
      open();
    } catch (e) {}
  }

  window.rpCartDrawerInit = function () { bind(); bindTriggers(); interceptForms(); interceptAdds(); applyGift(); ouvrirSiDemande(); };

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.rpCartDrawerInit);
  } else {
    window.rpCartDrawerInit();
  }
})();
